import {all, fork, take, call, put, select, delay} from 'redux-saga/effects'
import {eventChannel} from 'redux-saga'
import API from "../api/api";
import {CODES} from "../constants";
import {getCurrentStore, getUserInfo} from "../reducers/app";
import {getOrders, watchOrders, watchRefund} from "../containers/Orders/sagas";
import {getSettlements, watchSettlements} from "../containers/Settlements/sagas";
import {watchSettingsChange} from "../containers/BasicInfo/saga";
import {getUserList, watchUserChange, watchUsers} from "../containers/Users/saga";
import {getDeveloperInfo, watchGetSignKey} from "../containers/Developer/saga";
import {getIndexStat, watchCashier} from "../containers/DashBoard/saga";
import {merchantInfo} from "../reducers/merchant";
import {CHAINTYPES, PAY_STATUS, ROLES} from "../reducers/types";
import {toast} from "react-toastify";
import {globalIntl} from "../containers/App/App";
import {getAccount, watchCashChange} from "../containers/AccountInfo/saga";
import { watchLink, clearLink } from "../containers/CreateLink/saga"
import { getLinkList, watchSearchLink, watchClearFilters, watchLinkPageChange, watchLinkSizeChange } from "../containers/SearchLink/sagas"
import { getCurrencyList, watchExchangeAmt, watchExchangeSubmit, resetExchange, watchCurrencychange } from "../containers/ExchangeApply/saga"
import { getRecordsInfo, watchFiltersChange, watchExchangeIndexChange, watchExchangeSizeChange, watchExchangeReload } from "../containers/ExchangeRecords/saga"
///===============================

export function* isInfoInStorage(): Generator<any, void, any> {
    let userInfo = yield localStorage.getItem('S4P_UserInfo');
    if (userInfo) {
        return userInfo
    }
    return
}

export function* initUserInfo(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    if (!userInfo) {
        userInfo = yield isInfoInStorage()
        if (userInfo) {
            let userInfoJson = JSON.parse(userInfo)
            yield put({type: 'SET_USER_INFO', payload: userInfoJson})
            yield put({type: 'INIT_SOCKET', payload: {websocket: userInfoJson.websocket}})
        }
    }
}

export function* getMerchantInfo(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    if (userInfo && userInfo.email) {
        let params = {
            email: userInfo.email,
            clientId: 'h5'
        }
        let resp = yield call(API.getMerchantInfo, params)
        if (resp.code === CODES.SUCCESS && resp.data) {
            console.log("@!!!!!!!!!!!!1")
            yield put({type: 'SET_MERCHANT_INFO', payload: resp.data})
            if (resp.data.chainType === CHAINTYPES.SINGLE && userInfo.role === ROLES.ADMIN) {
                // 单店如果是门店管理员，把角色设置为超级管理员，方便权限管理
                yield put({type: 'SET_USER_ROLE', payload: {role: ROLES.SUPER_ADMIN}})
            }
        }
    }
}

export function* getStoreList(): Generator<any, void, any> {
    let userInfo = yield select(getUserInfo)
    console.log(userInfo)
    let params = {
        email: userInfo.email,
        clientId: 'h5',
        currentPage: 1,
        recordsPerPage: 20
    }
    let resp = yield call(API.getStoreList, params)
    if (resp.code === CODES.SUCCESS && resp.data) {
        console.log(resp.data)
        yield put({type: 'SET_STORE_LIST', payload: resp.data})
    }
}

function* initPageParam(): Generator<any, void, any> {
    let recordsPerPage = yield localStorage.getItem('S4P_RercodesPerPage') || 20;
    yield put({type: 'INIT_RECORDS_PER_PAGE', payload: {recordsPerPage: recordsPerPage}})
}

function* loadPage(page: string) {
    switch (page) {
        case 'dashboard':
            yield fork(getIndexStat)
            break;
        case 'orders':
            yield fork(getUserList)
            yield fork(getOrders, {currentPage: 1})
            break;
        case 'users':
            yield fork(getUserList, {currentPage: 1})
            break;
        case 'settlements':
            yield fork(getSettlements, {currentPage: 1})
            break;
        case 'basicInfo':
            // yield fork(getMerchantInfo)
            break;
        case 'account':
            yield fork(getAccount)
            break;
        case 'createLink':
            yield fork(clearLink)
            break;
		case 'searchLink':
			yield fork(getLinkList)
			break;
		case 'exchangeApply':
			yield fork(getCurrencyList)
			yield fork(getAccount)
			yield fork(resetExchange)
			break;
		case 'exchangeRecords':
			yield fork(getRecordsInfo)
			break;
        case 'developer':
            yield fork(getDeveloperInfo)
            break;
        default:
            return
    }
}

function createSocketChannel(socket: WebSocket) {
    let interval: any = null
    return eventChannel(emit => {
        // 设定 subscription
        socket.onmessage = function (event: MessageEvent) {
            console.log('on message', event)
            emit({type: 'message', data: event.data})
        }
        socket.onopen = function (event: Event) {
            emit({type: 'open'})
            interval = window.setInterval(() => {
                console.log('socket ping')
                socket.send("ping");
            }, 9 * 60 * 1000)
        }
        socket.onerror = (e: Event) => {
            // 发生了一个错误
            console.error(e)
            emit({type: 'error'})
            if (interval) {
                window.clearInterval(interval)
                interval = null
            }
        };
        socket.onclose = (e: Event) => {
            // 发生了一个错误
            console.error(e)
            emit({type: 'close'})
            if (interval) {
                window.clearInterval(interval)
                interval = null
            }
        };
        // subscriber 必须返回一个 unsubscribe 函数
        // unsubscribe 将在 saga 调用 `channel.close` 方法时被调用
        const unsubscribe = () => {
        }

        return unsubscribe
    })
}


///===============================
function* loginFlow(): Generator<any, void, any> {
    while (true) {
        const {payload} = yield take('LOGIN')
        let {history, ...rest} = payload
        let response = yield call(API.login, rest)
        if (response.code === CODES.SUCCESS) {
            yield localStorage.setItem('S4P_UserInfo', JSON.stringify(response.data));
            yield put({type: 'SET_USER_INFO', payload: response.data})
            yield put({type: 'INIT_SOCKET', payload: {websocket: response.data.websocket}})
            history.replace('/app/dashboard')
            // window.location.href = "/#/app/dashboard"
        }
    }
}

function* logoutFlow(): Generator<any, void, any> {
    while (true) {
        yield take(['LOGOUT', 'NOT_LOGIN'])
        let userInfo = yield select(getUserInfo)
        if (userInfo) {
            let params = {
                email: userInfo.email,
                clientId: 'h5',
            }
            let response = yield call(API.logout, params)
            if (response.code === CODES.SUCCESS) {
                yield localStorage.removeItem('S4P_UserInfo');
                yield put({type: 'SET_USER_INFO', payload: undefined})
                yield put({type: 'CLEAR_CASHIER', payload: undefined})
                window.location.href = "/#/login"
            }
        }
        else {
            yield localStorage.removeItem('S4P_UserInfo');
            yield put({type: 'SET_USER_INFO', payload: undefined})
            yield put({type: 'CLEAR_CASHIER', payload: undefined})
            window.location.href = "/#/login"
        }

    }
}

function* watchTopBarStoreChange() {
    while (true) {
        const {payload} = yield take('TOP_BAR_CHANGE_STORE')
        yield put({type: 'TOP_BAR_CHANGE_CURRENT_STORE', payload: {storeId: payload.storeId}})
        if (payload.page === 'dashboard') {
            yield fork(getIndexStat)
        } else if (payload.page === 'orders') {
            yield fork(getOrders, {})
        } else if (payload.page === 'users') {
            yield fork(getUserList)
        }
    }
}

function* watchMain() {
    while (true) {
        let {payload} = yield take('LOAD_MAIN')
        yield call(initUserInfo)
        yield call(initPageParam)

        yield fork(getMerchantInfo)

        if (payload.page) {
            yield put({type: 'LOAD_PAGE', payload: payload})
        }
    }
}

function* watchPageChange() {
    while (true) {
        let {payload} = yield take('LOAD_PAGE')
        yield fork(loadPage, payload.page)
    }
}

function* watchSocket(): Generator<any, void, any> {
    let action = yield take('INIT_SOCKET')
    if (!action.payload || !action.payload.websocket) {
        return
    }
    let ws = new WebSocket(action.payload.websocket);
    let socketChannel = yield call(createSocketChannel, ws)

    while (true) {
        const payload = yield take(socketChannel)
        if (payload.type === 'open') {
            yield put({type: 'SOCKET_CONNECTED'})
        } else if (payload.type === 'message') {
            console.log('socket message')
            let data = payload.data
            try {
                let jsonData = JSON.parse(data)
                if (jsonData.status === PAY_STATUS.PAY_SUCCESS) {
                    let merchant = yield select(merchantInfo)
                    toast.success(globalIntl.formatMessage({id: 'newOrderNoitf'}) + jsonData.tradeAmt + merchant.currency)

                    let currentStore = yield select(getCurrentStore)
                    if (currentStore === null || currentStore === jsonData.storeId) {
                        yield put({type: 'ON_SOCKET_MESSAGE', payload: jsonData})
                    }

                    let iframe = document.getElementById('audio-iframe') as HTMLIFrameElement
                    if (iframe && iframe.contentDocument) {
                        let audio = iframe.contentDocument.getElementById('notify-sound') as HTMLAudioElement
                        audio.muted = false
                        audio.play().then((m) => {
                            console.log(m)
                        }).catch((error) => {
                            console.error(error)
                        })
                    }
                }
            } catch (e) {
                console.error(e)
            }
        } else if (payload.type === 'error' || payload.type === 'close') {
            console.info("socket:", payload.type)
            yield put({type: 'SOCKET_DISCONNECTED'})
            yield delay(3000)
            let ws = new WebSocket(action.payload.websocket);
            socketChannel = yield call(createSocketChannel, ws)
            // yield put({type: 'INIT_SOCKET', payload})
        }
    }
}

function countdown(secs: number) {
    return eventChannel(emitter => {
            const iv = window.setInterval(() => {
                secs -= 1
                if (secs > 0) {
                    emitter(secs)
                } else {
                    // 这里将导致 channel 关闭
                    emitter('END')
                }
            }, 1000);
            // subscriber 必须回传一个 unsubscribe 函数
            return () => {
                clearInterval(iv)
            }
        }
    )
}


export function* counterSaga(): Generator<any, void, any> {
    let channel = yield call(countdown, 60)
    yield put({type: 'SEND_BUTTON_STATUS', payload: {countdown: 60}})
    try {
        while (true) {
            let seconds = yield take(channel)
            yield put({type: 'SEND_BUTTON_STATUS', payload: {countdown: seconds}})
            console.log(`countdown: ${seconds}`)
            if (seconds === 'END') {
                channel.close()
            }
        }
    } finally {
        yield put({type: 'SEND_BUTTON_STATUS', payload: {countdown: 0}})
        console.log('countdown cancelled')
    }
}


function* watchForgot(): Generator<any, void, any> {
    while (true) {
        const {payload} = yield take('FORGOT_PASSWORD')
        let response = yield call(API.forgotPassword, payload)
        if (response.code === CODES.SUCCESS) {
            toast(globalIntl.formatMessage({id: 'sendSucc'}))
            yield fork(counterSaga)
        }
    }
}

function* watchResetPass(): Generator<any, void, any> {
    while (true) {
        const {payload} = yield take('RESET_PASSWORD')
        let response = yield call(API.resetPassword, payload)
        if (response.code === CODES.SUCCESS) {
            toast(globalIntl.formatMessage({id: 'resetSucc'}))
            window.location.href = '/#/login'
        }
    }
}


function *watchStoreList(){
    while(true){
        yield take('GET_STORE_LIST')
        yield fork(getStoreList)
    }
}

///===============================

export default function* appSaga() {
    yield all([
        fork(watchMain),
        fork(loginFlow),
        fork(logoutFlow),
        fork(watchOrders),
        fork(watchSettlements),
        fork(watchSettingsChange),
        fork(watchUsers),
        fork(watchUserChange),
        fork(watchRefund),
        fork(watchCashier),
        fork(watchTopBarStoreChange),
        fork(watchPageChange),
        fork(watchGetSignKey),
        fork(watchSocket),
        fork(watchForgot),
        fork(watchResetPass),
        fork(watchStoreList),
        fork(watchCashChange),
		fork(watchLink),
		fork(watchSearchLink),
		fork(watchClearFilters),
		fork(watchLinkPageChange),
		fork(watchLinkSizeChange),
		fork(watchExchangeAmt),
		fork(watchExchangeSubmit),
		fork(watchCurrencychange),
		fork(watchFiltersChange),
		fork(watchExchangeIndexChange),
		fork(watchExchangeSizeChange),
		fork(watchExchangeReload)
        // fork(counterSaga)
    ])
}
